// hooks/useLivePrices.js

import { useState, useEffect, useRef, useCallback } from "react";

// const useLivePrices = () => {
//   const [prices, setPrices] = useState({});
//   const [isLive, setIsLive] = useState(false);
//   const userIdRef = useRef(null);
//   const pendingRef = useRef(null);
//   const BASE_URL = process.env.REACT_APP_API_BASE_URL;

//   // Connect SSE once on mount
//   useEffect(() => {
//     const es = new EventSource(`${BASE_URL}/api/live/feed`);

//     es.addEventListener("connected", (e) => {
//       userIdRef.current = JSON.parse(e.data).userId;
//       setIsLive(true);

//       // If symbols were queued before connection, subscribe now
//       if (pendingRef.current) {
//         subscribeSymbols(pendingRef.current);
//         pendingRef.current = null;
//       }
//     });

//     es.addEventListener("snapshot", (e) => {
//       setPrices((prev) => ({ ...prev, ...JSON.parse(e.data) }));
//     });

//     es.addEventListener("tick", (e) => {
//       const d = JSON.parse(e.data);
//       setPrices((prev) => ({ ...prev, [d.symbol]: d }));
//     });

//     es.onerror = () => setIsLive(false);

//     return () => {
//       es.close();
//       setIsLive(false);
//     };
//   }, []);

//   // Call this when user switches index
//   const subscribeSymbols = useCallback(async (symbols) => {
//     if (!userIdRef.current) {
//       pendingRef.current = symbols;
//       return;
//     }

//     setPrices({});

//     await fetch("/api/live/symbols", {
//       method: "POST",
//       headers: { "Content-Type": "application/json" },
//       body: JSON.stringify({
//         userId: userIdRef.current,
//         symbols,
//       }),
//     });
//   }, []);

//   return { prices, isLive, subscribeSymbols };
// };
// const useLivePrices = () => {
//   const [prices, setPrices] = useState({});
//   const [isLive, setIsLive] = useState(false);
//   const userIdRef = useRef(null);
//   const pendingRef = useRef(null);
//   const BASE_URL = process.env.REACT_APP_API_BASE_URL;

//   useEffect(() => {
//     // Debug: make sure URL is correct
//     console.log("[SSE] BASE_URL:", BASE_URL);
//     console.log("[SSE] Connecting to:", `${BASE_URL}/api/live/feed`);

//     const es = new EventSource(`${BASE_URL}/api/live/feed`);

//     es.addEventListener("connected", (e) => {
//       userIdRef.current = JSON.parse(e.data).userId;
//       setIsLive(true);
//       console.log("[SSE] Connected, userId:", userIdRef.current);

//       if (pendingRef.current) {
//         subscribeSymbols(pendingRef.current);
//         pendingRef.current = null;
//       }
//     });

//     es.addEventListener("snapshot", (e) => {
//       const data = JSON.parse(e.data);
//       console.log("[SSE] Snapshot:", Object.keys(data).length, "stocks");
//       setPrices((prev) => ({ ...prev, ...data }));
//     });

//     es.addEventListener("tick", (e) => {
//       const d = JSON.parse(e.data);
//       setPrices((prev) => ({ ...prev, [d.symbol]: d }));
//     });

//     es.onerror = () => setIsLive(false);

//     return () => {
//       es.close();
//       setIsLive(false);
//     };
//   }, []);

//   // FIX: Use BASE_URL here too
//   const subscribeSymbols = useCallback(
//     async (symbols) => {
//       if (!userIdRef.current) {
//         pendingRef.current = symbols;
//         return;
//       }

//       setPrices({});

//       await fetch(`${BASE_URL}/api/live/symbols`, {
//         // ← was missing BASE_URL
//         method: "POST",
//         headers: { "Content-Type": "application/json" },
//         body: JSON.stringify({
//           userId: userIdRef.current,
//           symbols,
//         }),
//       });
//     },
//     [BASE_URL],
//   ); // ← add BASE_URL to deps

//   return { prices, isLive, subscribeSymbols };
// };
// const useLivePrices = () => {
//   const [prices, setPrices] = useState({});
//   const [lastTickTime, setLastTickTime] = useState(null);
//   const [isLive, setIsLive] = useState(false);
//   const userIdRef = useRef(null);
//   const pendingRef = useRef(null);
//   const esRef = useRef(null);
//   const symbolsRef = useRef([]); // track current symbols
//   const BASE_URL = process.env.REACT_APP_API_BASE_URL;

//   const connectSSE = useCallback(() => {
//     // Close existing connection if any
//     if (esRef.current) {
//       esRef.current.close();
//       esRef.current = null;
//     }

//     console.log("[SSE] Connecting...");
//     const es = new EventSource(`${BASE_URL}/api/live/feed`);
//     esRef.current = es;

//     es.addEventListener("connected", (e) => {
//       userIdRef.current = JSON.parse(e.data).userId;
//       setIsLive(true);
//       console.log("[SSE] Connected, userId:", userIdRef.current);
//       //  setLastTickTime(new Date().toISOString());

//       // Re-subscribe symbols on reconnect
//       if (symbolsRef.current.length) {
//         subscribeSymbols(symbolsRef.current);
//       }

//       if (pendingRef.current) {
//         subscribeSymbols(pendingRef.current);
//         pendingRef.current = null;
//       }
//     });

//     es.addEventListener("snapshot", (e) => {
//       const data = JSON.parse(e.data);
//       setPrices((prev) => ({ ...prev, ...data }));
//       setLastTickTime(new Date().toISOString());
//     });

//     es.addEventListener("tick", (e) => {
//       const d = JSON.parse(e.data);
//       console.log("[SSE] Tick received for:", d.symbol);
//       setPrices((prev) => ({ ...prev, [d.symbol]: d }));
//       setLastTickTime(new Date().toISOString());
//     });

//     es.onerror = () => {
//       setIsLive(false);
//       console.log("[SSE] Error — will reconnect on visibility");
//     };
//   }, [BASE_URL]);

//   // Initial connect
//   useEffect(() => {
//     connectSSE();
//     return () => {
//       if (esRef.current) {
//         esRef.current.close();
//         setIsLive(false);
//       }
//     };
//   }, [connectSSE]);

//   // Reconnect when tab becomes visible again (after sleep/switch)
//   useEffect(() => {
//     const handleVisibility = () => {
//       if (document.visibilityState === "visible") {
//         console.log("[SSE] Tab visible — checking connection");

//         const es = esRef.current;
//         // readyState: 0=CONNECTING, 1=OPEN, 2=CLOSED
//         if (!es || es.readyState === 2) {
//           console.log("[SSE] Connection dead — reconnecting");
//           connectSSE();
//         }
//       }
//     };

//     document.addEventListener("visibilitychange", handleVisibility);

//     return () => {
//       document.removeEventListener("visibilitychange", handleVisibility);
//     };
//   }, [connectSSE]);

//   const subscribeSymbols = useCallback(
//     async (symbols) => {
//       // Save symbols so we can re-subscribe on reconnect
//       symbolsRef.current = symbols;

//       if (!userIdRef.current) {
//         pendingRef.current = symbols;
//         return;
//       }

//       setPrices({});

//       await fetch(`${BASE_URL}/api/live/symbols`, {
//         method: "POST",
//         headers: { "Content-Type": "application/json" },
//         body: JSON.stringify({
//           userId: userIdRef.current,
//           symbols,
//         }),
//       });
//     },
//     [BASE_URL],
//   );

//   return { prices, isLive, subscribeSymbols, lastTickTime };
// };
const useLivePrices = () => {
  const [prices, setPrices] = useState({});
  const [isLive, setIsLive] = useState(false);
  const [lastTickTime, setLastTickTime] = useState(null);
  const [connectionStatus, setConnectionStatus] = useState("connecting");
  const userIdRef = useRef(null);
  const pendingRef = useRef(null);
  const esRef = useRef(null);
  const symbolsRef = useRef([]);
  const bufferRef = useRef({});
  const flushTimerRef = useRef(null);

  const BASE_URL =
    process.env.REACT_APP_LIVE_URL || process.env.REACT_APP_API_BASE_URL;

  const FLUSH_INTERVAL = 1000;

  // Check if market is open
  const isMarketOpen = useCallback(() => {
    const now = new Date();
    const ist = new Date(
      now.toLocaleString("en-US", { timeZone: "Asia/Kolkata" }),
    );
    const day = ist.getDay();
    const mins = ist.getHours() * 60 + ist.getMinutes();

    // Mon-Fri, 9:00 AM to 3:45 PM (buffer after 3:30 close)
    return day >= 1 && day <= 5 && mins >= 540 && mins <= 945;
  }, []);

  const cleanup = useCallback(() => {
    if (esRef.current) {
      esRef.current.close();
      esRef.current = null;
    }
    if (flushTimerRef.current) {
      clearInterval(flushTimerRef.current);
      flushTimerRef.current = null;
    }
  }, []);

  const flushBuffer = useCallback(() => {
    const buffer = bufferRef.current;
    if (Object.keys(buffer).length === 0) return;

    setPrices((prev) => ({ ...prev, ...buffer }));
    setLastTickTime(new Date().toISOString());
    bufferRef.current = {};
  }, []);

  const connectSSE = useCallback(() => {
    // Don't connect if market is closed
    if (!isMarketOpen()) {
      setConnectionStatus("closed");
      setIsLive(false);
      cleanup();
      return;
    }

    cleanup();

    const es = new EventSource(`${BASE_URL}/api/live/feed`);
    esRef.current = es;

    flushTimerRef.current = setInterval(flushBuffer, FLUSH_INTERVAL);

    es.addEventListener("connected", (e) => {
      userIdRef.current = JSON.parse(e.data).userId;
      setIsLive(true);
      setConnectionStatus("live");

      if (symbolsRef.current.length) {
        subscribeSymbols(symbolsRef.current);
      }
      if (pendingRef.current) {
        subscribeSymbols(pendingRef.current);
        pendingRef.current = null;
      }
    });

    es.addEventListener("snapshot", (e) => {
      const data = JSON.parse(e.data);
      setPrices((prev) => ({ ...prev, ...data }));
      setLastTickTime(new Date().toISOString());
    });

    es.addEventListener("tick", (e) => {
      const d = JSON.parse(e.data);
      bufferRef.current[d.symbol] = d;
    });

    es.onerror = () => {
      setIsLive(false);
      setConnectionStatus("disconnected");
    };
  }, [BASE_URL, flushBuffer, isMarketOpen, cleanup]);

  // Initial connect
  useEffect(() => {
    connectSSE();
    return cleanup;
  }, [connectSSE, cleanup]);

  // Reconnect on tab visible — only if market open
  useEffect(() => {
    const handleVisibility = () => {
      if (document.visibilityState === "visible") {
        if (!isMarketOpen()) {
          setConnectionStatus("closed");
          cleanup();
          return;
        }

        const es = esRef.current;
        if (!es || es.readyState === 2) {
          connectSSE();
        }
      }
    };

    document.addEventListener("visibilitychange", handleVisibility);
    return () => {
      document.removeEventListener("visibilitychange", handleVisibility);
    };
  }, [connectSSE, isMarketOpen, cleanup]);

  // Auto-close SSE when market closes (check every minute)
  useEffect(() => {
    const checker = setInterval(() => {
      if (!isMarketOpen() && esRef.current) {
        cleanup();
        setIsLive(false);
        setConnectionStatus("closed");
      }
    }, 60000); // check every 60 seconds

    return () => clearInterval(checker);
  }, [isMarketOpen, cleanup]);

  const subscribeSymbols = useCallback(
    async (symbols) => {
      symbolsRef.current = symbols;

      if (!userIdRef.current) {
        pendingRef.current = symbols;
        return;
      }

      setPrices({});

      await fetch(`${BASE_URL}/api/live/symbols`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({
          userId: userIdRef.current,
          symbols,
        }),
      });
    },
    [BASE_URL],
  );
  const subscribeFullDepth = useCallback(
    async (securityId, exchangeSegment = "NSE_EQ") => {
      await fetch(`${BASE_URL}/api/live/subscribe-full`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ securityId, exchangeSegment }),
      });
    },
    [BASE_URL],
  );

  const unsubscribeFullDepth = useCallback(
    async (securityId, exchangeSegment = "NSE_EQ") => {
      await fetch(`${BASE_URL}/api/live/unsubscribe-full`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ securityId, exchangeSegment }),
      });
    },
    [BASE_URL],
  );

  return {
    prices,
    isLive,
    subscribeSymbols,
    lastTickTime,
    connectionStatus,
    subscribeFullDepth,
    unsubscribeFullDepth,
  };
};

export default useLivePrices;
